import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { Plus, Minus, Trash2 } from "lucide-react";

export default function Cart() {
  const { items, updateQty, removeItem, subtotal } = useCart();
  const shipping = subtotal >= 75 || subtotal === 0 ? 0 : 9.99;
  const tax = subtotal * 0.0825;
  const total = subtotal + shipping + tax;

  return (
    <div className="bg-white" data-testid="cart-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="rh-overline mb-3">Step 01 / 03</div>
        <h1 className="font-display font-black text-4xl lg:text-5xl tracking-tighter mb-10">Your Cart</h1>

        {items.length === 0 ? (
          <div className="border border-[#0a0a0a] py-16 px-6 text-center">
            <p className="text-[#4a4a4a] mb-6">Your cart is currently empty.</p>
            <Link to="/shop" className="rh-btn-primary">Browse Products</Link>
          </div>
        ) : (
          <div className="grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-8">
              <div className="border-t border-[#0a0a0a]">
                {items.map((i) => (
                  <div key={i.product_id} className="flex gap-5 py-6 border-b border-[#e5e5e5]" data-testid={`cart-row-${i.product_id}`}>
                    <Link to={`/product/${i.product_id}`} className="w-28 h-28 bg-[#f5f5f5] flex-shrink-0 block">
                      <img src={i.image} alt={i.name} className="w-full h-full object-cover" />
                    </Link>
                    <div className="flex-1 flex flex-col justify-between">
                      <div>
                        <div className="font-mono text-[10px] uppercase tracking-widest text-[#4a4a4a]">{i.brand}</div>
                        <Link to={`/product/${i.product_id}`} className="font-semibold text-base hover:text-[#002fa7]">{i.name}</Link>
                      </div>
                      <div className="flex items-center justify-between mt-4">
                        <div className="flex items-center border border-[#0a0a0a]">
                          <button onClick={() => updateQty(i.product_id, i.quantity - 1)} className="px-3 py-2 hover:bg-[#f5f5f5]"><Minus size={12} /></button>
                          <span className="px-4 text-sm rh-num">{i.quantity}</span>
                          <button onClick={() => updateQty(i.product_id, i.quantity + 1)} className="px-3 py-2 hover:bg-[#f5f5f5]"><Plus size={12} /></button>
                        </div>
                        <span className="font-display font-bold text-lg rh-num">${(i.price * i.quantity).toFixed(2)}</span>
                      </div>
                    </div>
                    <button onClick={() => removeItem(i.product_id)} className="text-[#4a4a4a] hover:text-[#ff3b30] self-start" data-testid={`cart-remove-${i.product_id}`}>
                      <Trash2 size={18} />
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:col-span-4">
              <div className="border border-[#0a0a0a] p-6 space-y-4 sticky top-32">
                <div className="rh-overline">Order summary</div>
                <div className="flex justify-between text-sm"><span className="text-[#4a4a4a]">Subtotal</span><span className="rh-num">${subtotal.toFixed(2)}</span></div>
                <div className="flex justify-between text-sm"><span className="text-[#4a4a4a]">Shipping</span><span className="rh-num">{shipping === 0 ? "FREE" : `$${shipping.toFixed(2)}`}</span></div>
                <div className="flex justify-between text-sm"><span className="text-[#4a4a4a]">Tax (8.25%)</span><span className="rh-num">${tax.toFixed(2)}</span></div>
                <div className="border-t border-[#0a0a0a] pt-4 flex justify-between items-baseline">
                  <span className="font-semibold">Total</span>
                  <span className="font-display font-black text-2xl rh-num" data-testid="cart-total">${total.toFixed(2)}</span>
                </div>
                <Link data-testid="checkout-btn" to="/checkout" className="rh-btn-primary w-full text-center block">Checkout</Link>
                <Link to="/shop" className="block text-center text-xs uppercase tracking-widest underline">Continue shopping</Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
